import { StyledSearchBar, useDebouncedSearch } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { searchConvoyState } from '../../storage/convoys';

function ConvoyFilters() {
  const { search, setSearch } = useDebouncedSearch(useRecoilState(searchConvoyState));

  return (
    <StyledSearchBar
      name={'convoy-search'}
      value={search}
      onChange={(value) => setSearch(value)}
      clearable
      noMargin
    />
  );
}

export default memo(ConvoyFilters);
